/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * CESmon API
 * OpenAPI spec version: 0.0.1
 */
import { HttpClient, HttpHeaders, HttpResponse as AngularHttpResponse } from '@angular/common/http';
import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type { EventLogType, GetEventLogTypeDetailResourcePathParameters } from '../model';

interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?: HttpParams | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: { includeHeaders?: string[] } | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

@Injectable({ providedIn: 'root' })
export class EventLogTypesService {
  private readonly http = inject(HttpClient);
  /**
   * @summary List event log type entries
   */
  getEventLogTypeListResource<TData = EventLogType[]>(options?: HttpClientBodyOptions): Observable<TData>;
  getEventLogTypeListResource<TData = EventLogType[]>(options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
  getEventLogTypeListResource<TData = EventLogType[]>(options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getEventLogTypeListResource<TData = EventLogType[]>(
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`/event-log-types`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`/event-log-types`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`/event-log-types`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * @summary Retrieve an event log type by id
   */
  getEventLogTypeDetailResource<TData = EventLogType>(
    pathParams: GetEventLogTypeDetailResourcePathParameters,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  getEventLogTypeDetailResource<TData = EventLogType>(
    pathParams: GetEventLogTypeDetailResourcePathParameters,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  getEventLogTypeDetailResource<TData = EventLogType>(
    pathParams: GetEventLogTypeDetailResourcePathParameters,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getEventLogTypeDetailResource<TData = EventLogType>(
    { id }: GetEventLogTypeDetailResourcePathParameters,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`/event-log-types/${id}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`/event-log-types/${id}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`/event-log-types/${id}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
}
